import './styles/main.scss'
import SiteSlider from './scripts/SiteSlider'


const allSlider = new SiteSlider()
